const find = require('lodash/find');

const findFirstTag = ({ tagName, properties, children }, tag) => {
  if (tag === tagName) {
    return properties;
  }
  let result;
  find(children, child => {
    const props = findFirstTag(child, tag);
    if (props) {
      result = props;
      return true;
    }
    return false;
  });
  return result;
};

module.exports = {
  getFirstImage: ast => findFirstTag(ast, 'img')
};
